/**
 * Framer Motion's drag `info.point` is built from `pageX` / `pageY` (document space).
 * Hit-testing with `getBoundingClientRect()` needs viewport coordinates (`clientX` / `clientY`).
 * When the page or a scrollable ancestor is scrolled, mixing the two breaks drop detection.
 *
 * @param {MouseEvent | PointerEvent | TouchEvent | undefined} event
 * @param {{ point: { x: number; y: number } }} info
 * @returns {{ x: number; y: number }}
 */
export function viewportPointerFromDragEnd(event, info) {
  if (event && typeof event.clientX === 'number' && typeof event.clientY === 'number') {
    return { x: event.clientX, y: event.clientY };
  }
  if (event && 'changedTouches' in event && event.changedTouches?.length) {
    const t = event.changedTouches[0];
    return { x: t.clientX, y: t.clientY };
  }
  if (info?.point && typeof info.point.x === 'number' && typeof info.point.y === 'number') {
    return { x: info.point.x, y: info.point.y };
  }
  return { x: 0, y: 0 };
}
